"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Pricing() {
  return <section id="what-affects-the-price" data-nav="light" className="bg-background text-foreground border-t border-border py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <div className="max-w-4xl">
          <div>
            <div className="inline-flex items-center gap-2 border border-border bg-muted px-3 py-1 text-xs font-mono uppercase tracking-wider text-muted-foreground mb-6">
              <span>Cost engineering breakdown</span>
            </div>

            <h2 className="font-serif uppercase font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-foreground">
              How Much Does a Mechanical Bull Cost?
            </h2>

            <p className="mt-6 text-base sm:text-lg leading-relaxed text-muted-foreground font-default">
              The price of a mechanical bull depends on the exact machine, its condition, the system included and what comes with the package.
              <br /><br />
              There is no useful single price that applies to every mechanical bull.
              <br /><br />
              A complete setup may include the bull, motion base, controller, inflatable safety area, blower and other components, while another advertised price may cover a different combination of equipment.
              <br /><br />
              Used equipment introduces additional factors such as age, wear, previous repairs, controller condition and what parts still come with the unit.
              <br /><br />
              When comparing mechanical bull prices, check:
            </p>

            <div className="mt-8 border-l-2 border-primary pl-5 py-1">
              <div className="space-y-3">
                <div>
                  <p className="font-semibold text-foreground text-sm sm:text-base">New or used condition</p>
                  <p className="text-sm sm:text-base text-muted-foreground mt-0.5">New and pre-owned machines should not be compared solely by the headline price.</p>
                </div>
                <div>
                  <p className="font-semibold text-foreground text-sm sm:text-base">What the package actually includes</p>
                  <p className="text-sm sm:text-base text-muted-foreground mt-0.5">A lower advertised price may represent a different equipment package.</p>
                </div>
                <div>
                  <p className="font-semibold text-foreground text-sm sm:text-base">Controller and operating system</p>
                  <p className="text-sm sm:text-base text-muted-foreground mt-0.5">Different systems may use different controls, modes and components.</p>
                </div>
                <div>
                  <p className="font-semibold text-foreground text-sm sm:text-base">Inflatable and blower</p>
                  <p className="text-sm sm:text-base text-muted-foreground mt-0.5">Confirm whether the complete safety area and blower are included.</p>
                </div>
                <div>
                  <p className="font-semibold text-foreground text-sm sm:text-base">Condition of used equipment</p>
                  <p className="text-sm sm:text-base text-muted-foreground mt-0.5">Age alone tells you very little. Controller, base, inflatable, electrical components and service history matter.</p>
                </div>
                <div>
                  <p className="font-semibold text-foreground text-sm sm:text-base">Freight and delivery</p>
                  <p className="text-sm sm:text-base text-muted-foreground mt-0.5">Large equipment can involve significant transportation considerations.</p>
                </div>
                <div>
                  <p className="font-semibold text-foreground text-sm sm:text-base">Warranty and parts support</p>
                  <p className="text-sm sm:text-base text-muted-foreground mt-0.5">Where applicable, these can affect the real ownership value of a machine.</p>
                </div>
              </div>
              <p className="text-sm sm:text-base text-foreground font-medium mt-4">
                Instead of publishing a generic number that may not match what is actually for sale, our Price Guide is designed to use real inventory and current product pricing.
              </p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-border">
            <p className="text-xs font-mono uppercase text-muted-foreground mb-3">
              Commercial cost benchmark
            </p>
            <Link to="/MechanicalBullPriceGuidePage" className="group inline-flex items-center gap-2 text-base font-semibold text-primary transition-colors hover:text-foreground">
              <span>Read the mechanical bull price guide</span>
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}